import { Component } from '@angular/core';
import { EndPointUtils } from '../shared/utilities/end-points.utils';
import { TranslateService } from '@ngx-translate/core';
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    angulartics2GoogleTagManager: Angulartics2GoogleTagManager, private translate: TranslateService,
    private endPointUtils: EndPointUtils) {
    angulartics2GoogleTagManager.startTracking();
    this.useLanguage(this.endPointUtils.getAppLanguage());
  }
  useLanguage(language: string) {
    this.translate.use(language);
  }
}
